import { IPackageListingAppSettings, defaultSettings } from '../../custom/classes/package-listing-settings';
import { ActionType, IPackageListingStateAction } from '../../classes/package-listing-actions';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function packageListingSettingsReducer(state: IPackageListingAppSettings = defaultSettings, action: IPackageListingStateAction) {
    switch (action.type) {
        case ActionType.UpdateSettings: {
            return { ...state, ...action.value, requesting: false, apiError: null } as IPackageListingAppSettings;
        }
        case ActionType.LoadPackage: {
            return { ...state, useUnseatedReservation: action.value.useUnseatedReservation, isFixed: false } as IPackageListingAppSettings;
        }
        case ActionType.LoadPackageRequest: {
            return { ...state, isRenewal: true, currentRenewalPackageId: action.value.currentRenewalPackageId };
        }
        case ActionType.LoadPackages: {
            return { ...state, isFixed: true,  } as IPackageListingAppSettings;
        }
        default:
            return state;
    }
}
